// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Warning_wrapper___YiCf","note":"Warning_note__r4hjd","actions":"Warning_actions__TGuOW"};